// DEPRECATED - replaced by CategoriesGrid. Ensure its dismission in every store before delete it
import styled from 'styled-components'
import { Swiper } from 'swiper/react'
import type { CarouselStackSizes } from './CarouselsStack.types'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  padding: 3.6rem 0;

  @media screen and (min-width: 992px) {
    padding: 5rem 0;
  }
`

export const SlidersContainer = styled.div`
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media screen and (min-width: 992px) {
    margin: 0;
    gap: 4rem;
  }
`

export const StyledSwiper = styled(Swiper)<{
  $carouselStackSizes: {
    mobile: CarouselStackSizes
    desktop: CarouselStackSizes
  }
  $calculatedBreakpoint: number
}>`
  width: 100%;
  padding: 0
    ${({ $carouselStackSizes: carouselStackSizes }) =>
      carouselStackSizes.mobile.sliderSidePadding}px;

  @media screen and (min-width: 992px) {
    padding: 0
      ${({ $carouselStackSizes: carouselStackSizes }) =>
        carouselStackSizes.desktop.sliderSidePadding}px;
  }

  .swiper-slide {
    width: 100%;
    max-width: ${({ $carouselStackSizes: carouselStackSizes }) =>
      carouselStackSizes.mobile.slideMaxWidth}px;

    @media screen and (min-width: 768px) {
      max-width: ${({ $carouselStackSizes: carouselStackSizes }) =>
        carouselStackSizes.desktop.slideMaxWidth}px;
    }
  }

  .swiper-wrapper {
    @media screen and (min-width: ${(props) => props.$calculatedBreakpoint}px) {
      justify-content: center;
    }
  }
`
